import type { McVariant } from "../mcVariants";

// Adaptive Distraktor-Varianten fuer Hagen BGB-AT (KE 1), erzeugt vom MC-Anreicherungs-
// Schwarm (Autor -> question-reviewer-Gate, Pilot 2026-06-01). reviewStatus der Fragen bleibt
// unveraendert; schwer/sehr-schwer sind vom question-reviewer freigegeben, aber von Vincent
// final gegenzupruefen, bevor irgendetwas beta-ready gesetzt wird.
export const hagenBgbAt: Record<string, McVariant> = {
  "hagen-bgb-at1-005": {
    correctTexts: ["Private koennen ihre Rechtsverhaeltnisse grundsaetzlich selbst gestalten, insbesondere durch Vertrag."],
    distractorsByDifficulty: {
      einfach: [
        "Privatautonomie bedeutet, dass jeder Buerger Gesetze selbst erlassen darf.",
        "Privatautonomie verpflichtet jede Person, jeden angebotenen Vertrag anzunehmen.",
        "Privatautonomie gilt nur fuer Kaufleute und nicht fuer Privatpersonen.",
      ],
      medium: [
        "Privatautonomie bedeutet vor allem, dass jeder Vertrag zu seiner Wirksamkeit der notariellen Beurkundung bedarf.",
        "Privatautonomie ist gleichbedeutend mit der Vertragsfreiheit und umfasst keine weiteren Gestaltungsbefugnisse wie Eigentumsuebertragung oder Testierfreiheit.",
        "Privatautonomie raeumt den Parteien das Recht ein, durch Vereinbarung auch zwingendes Verbraucherschutzrecht wirksam abzubedingen.",
      ],
      schwer: [
        "Privatautonomie ist die in Art. 2 Abs. 1 GG und § 311 Abs. 1 BGB verankerte Freiheit, wobei eine Inhaltskontrolle der Vereinbarung nach §§ 138, 242 BGB von vornherein ausgeschlossen bleibt.",
        "Privatautonomie meint die Selbstbestimmung der Parteien, deren Grenzen sich abschliessend allein aus § 134 BGB (gesetzliches Verbot) ergeben, nicht aber aus § 138 BGB.",
        "Privatautonomie gewaehrt zwar Abschluss- und Gestaltungsfreiheit, schliesst aber einen gesetzlich angeordneten Kontrahierungszwang in jedem Fall aus.",
      ],
      "sehr-schwer": [
        "Privatautonomie ist die rechtsgeschaeftliche Selbstbestimmung; sie wird jedoch durch das Abstraktionsprinzip dahin begrenzt, dass die Parteien Verpflichtungs- und Verfuegungsgeschaeft nicht eigenstaendig miteinander verknuepfen duerfen.",
        "Privatautonomie umfasst die Gestaltungsfreiheit der Parteien, reicht aber stets nur so weit, wie der gesetzliche Typenzwang des Schuldrechts die Schaffung neuer, gesetzlich nicht geregelter Vertragstypen zulaesst.",
        "Privatautonomie erlaubt es den Parteien kraft ihrer Gestaltungsfreiheit, die gesetzlichen Anfechtungsrechte wegen Irrtums (§§ 119 ff. BGB) fuer kuenftige eigene Willenserklaerungen im Voraus vollstaendig und unwiderruflich auszuschliessen.",
      ],
    },
  },
  "hagen-bgb-at1-009": {
    correctTexts: ["Er erklaert, warum erklaertes Verhalten unter Umstaenden zugerechnet wird, obwohl der innere Wille abweicht."],
    distractorsByDifficulty: {
      einfach: [
        "Er verpflichtet jeden zur notariellen Beurkundung seiner Erklaerungen.",
        "Er besagt, dass Schweigen im Rechtsverkehr stets als Zustimmung gilt.",
        "Er bedeutet, dass Vertraege nur unter Anwesenden wirksam geschlossen werden koennen.",
      ],
      medium: [
        "Er besagt, dass im Zweifel immer der wirkliche innere Wille des Erklaerenden Vorrang vor dem objektiven Erklaerungswert hat.",
        "Er ist ein Unterfall der culpa in contrahendo und begruendet nur Schadensersatz-, aber keine Erfuellungsansprueche.",
        "Er greift nur bei Formmangel und heilt die Nichtigkeit nach § 125 BGB durch Vollzug.",
      ],
      schwer: [
        "Er ist mit dem Grundsatz der Privatautonomie identisch und beschreibt allein die Freiheit, Erklaerungen abzugeben oder zu unterlassen.",
        "Er ist eine reine Auslegungsregel des § 133 BGB, die ausschliesslich den wirklichen Willen des Erklaerenden ermittelt.",
        "Er verpflichtet den Empfaenger einer Willenserklaerung stets zur Nachfrage beim Erklaerenden, bevor er auf den Erklaerungsinhalt vertrauen darf.",
      ],
      "sehr-schwer": [
        "Er bewirkt, dass eine geheime Mentalreservation nach § 116 Satz 1 BGB den Erklaerenden nur bindet, wenn der Empfaenger den Vorbehalt positiv kannte.",
        "Er ist deckungsgleich mit dem Verbot widerspruechlichen Verhaltens (venire contra factum proprium) aus § 242 BGB und entfaltet ausserhalb von Treu und Glauben keine Wirkung.",
        "Er rechtfertigt allein die Bindung an die Erklaerung, schliesst aber eine Anfechtung wegen Inhalts- oder Erklaerungsirrtums nach § 119 BGB von vornherein aus.",
      ],
    },
  },
  "hagen-bgb-at1-016": {
    correctTexts: ["Erst zu dem Zeitpunkt, zu dem nach der Verkehrsanschauung am naechsten Tag mit Leerung zu rechnen ist."],
    distractorsByDifficulty: {
      einfach: [
        "Sofort um 23:30 Uhr, weil der Briefkasten zum Machtbereich des B gehoert und es auf nichts weiter ankommt.",
        "Erst eine Woche spaeter, weil Kuendigungen generell eine Wartefrist von sieben Tagen haben.",
        "Gar nicht, weil eine Kuendigung zwingend per Einschreiben mit Rueckschein zugestellt werden muss.",
      ],
      medium: [
        "Sofort um 23:30 Uhr, sobald der Brief im Machtbereich des B liegt; auf die Kenntnisnahmemoeglichkeit kommt es nicht an.",
        "Erst um 00:00 Uhr mit Beginn des Folgetages, weil der Tag des Einwurfs nach § 187 BGB nicht mitzaehlt.",
        "Nie wirksam, weil ein naechtlicher Einwurf gegen Treu und Glauben (§ 242 BGB) verstoesst und den Zugang verhindert.",
      ],
      schwer: [
        "Sofort um 23:30 Uhr, weil mit dem Einwurf in den Machtbereich die abstrakte Kenntnisnahmemoeglichkeit bereits besteht und subjektive Umstaende des B unbeachtlich sind.",
        "Erst zum Zeitpunkt der tatsaechlichen Entnahme durch B, weil bei verspaetetem Einwurf ausnahmsweise auf die konkrete Kenntnisnahme abzustellen ist.",
        "Mit Ablauf des Einwurftages um 24:00 Uhr, da nach der Verkehrsanschauung die Leerung noch am selben Kalendertag erwartet werden darf.",
      ],
      "sehr-schwer": [
        "Zu dem Zeitpunkt am Folgetag, zu dem B aufgrund seiner individuellen, dem A bekannten Gewohnheiten seinen Briefkasten tatsaechlich zu leeren pflegt, da insoweit der konkrete Empfaengerhorizont massgeblich ist.",
        "Bereits am selben Tag zu der Uhrzeit, zu der die Postzustellung ortsueblich endet, weil sich die Verkehrsanschauung an den regelmaessigen Zustellzeiten und nicht an der Leerung orientiert.",
        "Erst zu Beginn der allgemeinen Geschaeftszeiten am Folgetag, weil fuer den Zugang gegenueber Privatpersonen dieselben Massstaebe wie bei Geschaeftsraeumen mit festen Oeffnungszeiten gelten.",
      ],
    },
  },
  "hagen-bgb-at1-020": {
    correctTexts: ["Als invitatio ad offerendum; K gibt regelmaessig erst das Angebot ab."],
    distractorsByDifficulty: {
      einfach: [
        "Als wirksamen Kaufvertrag, der bereits mit dem Hineinstellen ins Schaufenster zustande kommt.",
        "Als gesetzliches Schuldverhaeltnis, das ohne jede Erklaerung des K entsteht.",
        "Als einseitiges Rechtsgeschaeft des Haendlers, das den K sofort zur Zahlung verpflichtet.",
      ],
      medium: [
        "Als verbindliches Angebot des Haendlers gemaess § 145 BGB, das K durch 'Die nehme ich' wirksam annimmt.",
        "Als Realofferte, bei der allein die Warenentnahme den Vertrag schliesst.",
        "Als blosse Wissenserklaerung ueber den Lagerbestand ohne jeden rechtsgeschaeftlichen Bezug.",
      ],
      schwer: [
        "Als bindendes Angebot gemaess § 145 BGB, von dem sich der Haendler nur unter den Voraussetzungen des § 145 Halbsatz 2 BGB durch ausdruecklichen Vorbehalt loesen koennte.",
        "Als Angebot ad incertas personas, das mit der ersten Annahmeerklaerung des K nach § 151 BGB ohne Zugang zustande kommt.",
        "Als Aufforderung des Haendlers, die das spaetere 'Die nehme ich' des K bereits zur blossen Annahme nach § 147 BGB herabstuft.",
      ],
      "sehr-schwer": [
        "Als invitatio ad offerendum, bei der jedoch die Preisauszeichnungspflicht der PAngV das Schaufensterangebot ausnahmsweise zum bindenden Antrag nach § 145 BGB verdichtet.",
        "Als blosse Kaufanfrage des K, die noch kein Angebot im Sinne des § 145 BGB darstellt, sodass der Haendler erst durch seine Bestaetigung das Angebot abgibt.",
        "Als Angebot des Haendlers unter dem stillschweigenden Vorbehalt des § 145 Halbsatz 2 BGB, sodass erst dessen Bestaetigung den Vertrag begruendet.",
      ],
    },
  },
  "hagen-bgb-at1-034": {
    correctTexts: ["Nein, im Zweifel nicht, weil ein offener Einigungsmangel ueber einen wesentlichen Punkt besteht."],
    distractorsByDifficulty: {
      einfach: [
        "Ja, weil der Verkaeufer mit 3.600 Euro ein wirksames Angebot abgegeben hat, das der Kaeufer angenommen hat.",
        "Ja, denn ein Kaufvertrag entsteht schon, sobald sich die Parteien ueber den Kaufgegenstand geeinigt haben; der Preis ist unerheblich.",
        "Nein, weil ein Kaufvertrag ueber bewegliche Sachen stets der Schriftform nach § 126 BGB bedarf.",
      ],
      medium: [
        "Nein, es liegt ein versteckter Einigungsmangel nach § 155 BGB vor, sodass der Vertrag nicht zustande kommt.",
        "Ja, der Vertrag ist geschlossen; ueber den offenen Preis entscheidet im Zweifel der Verkaeufer nach billigem Ermessen gemaess § 315 BGB.",
        "Ja, denn nach § 154 Abs. 1 BGB kommt der Vertrag mit Einigung ueber die Hauptleistungspflichten zustande, auch wenn der Preis noch offen ist.",
      ],
      schwer: [
        "Nein, denn solange die Parteien einen Punkt fuer regelungsbeduerftig halten, liegt ein versteckter Einigungsmangel nach § 155 BGB vor, der den Vertrag scheitern laesst.",
        "Ja, der Vertrag ist geschlossen; mangels Preisbestimmung gilt nach § 612 Abs. 2 bzw. § 632 Abs. 2 BGB die uebliche Verguetung.",
        "Ja, der Vertrag ist wirksam, weil der Kaufpreis nach § 154 Abs. 2 BGB kein notwendiger Bestandteil der Einigung ist.",
      ],
      "sehr-schwer": [
        "Nein, weil ein versteckter Einigungsmangel nach § 155 BGB vorliegt: Die Parteien halten den Vertrag fuer geschlossen, haben sich aber ueber den Preis tatsaechlich nicht geeinigt.",
        "Ja, der Vertrag kommt zustande; der noch offene Kaufpreis ist nach § 315 Abs. 1 BGB im Zweifel durch den Verkaeufer nach billigem Ermessen zu bestimmen.",
        "Ja, der Vertrag ist geschlossen, da nach § 154 Abs. 1 S. 2 BGB die Verstaendigung ueber einzelne Punkte nicht bindet, ein Restdissens den Vertragsschluss insgesamt aber unberuehrt laesst.",
      ],
    },
  },
  "hagen-bgb-at1-046": {
    correctTexts: ["Der konkrete Sachverhalt wird unter die Tatbestandsmerkmale einer Norm geordnet."],
    distractorsByDifficulty: {
      einfach: [
        "Der Richter spricht das Urteil muendlich vor den Parteien aus.",
        "Der Klaeger reicht die Klageschrift beim zustaendigen Gericht ein.",
        "Ein Gesetz wird vom Bundestag beschlossen und verkuendet.",
      ],
      medium: [
        "Die einschlaegige Norm wird durch Auslegung ihres Wortlauts, Sinns und Zwecks inhaltlich bestimmt (Normauslegung, der Subsumtion vorgelagert).",
        "Aus dem festgestellten Sachverhalt wird die Rechtsfolge unmittelbar abgeleitet, ohne die Norm zu benennen.",
        "Der Sachverhalt wird in eine zeitlich geordnete Chronologie der Geschehnisse gebracht.",
      ],
      schwer: [
        "Die abstrakten Tatbestandsmerkmale einer Norm werden durch Definition naeher erlaeutert (Definitionsschritt im Gutachtenstil, der Subsumtion vorgelagert).",
        "Mehrere konkurrierende Anspruchsgrundlagen werden in ihrem Rangverhaeltnis geordnet (Konkurrenzlehre).",
        "Aus dem Vergleich mit einem aehnlichen, gesetzlich geregelten Fall wird eine Rechtsfolge fuer den ungeregelten Fall gewonnen (Analogie zur Schliessung einer planwidrigen Regelungsluecke).",
      ],
      "sehr-schwer": [
        "Das durch Auslegung gewonnene Tatbestandsmerkmal wird auf seine Vereinbarkeit mit hoeherrangigem Recht geprueft (verfassungskonforme Auslegung).",
        "Die tatsaechlich offenen Punkte des Geschehens werden durch richterliche Beweiswuerdigung festgestellt (Sachverhaltsfeststellung, der Subsumtion vorgelagert).",
        "Aus dem Ergebnis der Pruefung wird der Obersatz nachtraeglich so gebildet, dass die Rechtsfolge bestaetigt wird (ergebnisorientierter Schlusssatz).",
      ],
    },
  },
};
